import { http } from '../http';

export interface Templates {
    customerNo: number;
    favoriteSeq: number;
    isFavorite: string;
    templateId: number;
    templateName: string;
    trnType: string;
    userName: string;
    trnData: {
        BENEFBANKNAME: any;
        AMOUNT: number;
        APPROVE_DETAIL: []
        BENEFACC: string;
        BENEFACCTYPE: string;
        BENEFNAME: string;
        COMMAMOUNT: number;
        CUSTACC:string;
        CUSTCIF: string;
        PMTCUSTID: string;
        PMTDET: string;
        SIGN_DETAIL: any[];
        attachedPDF: number;
        source: string;
        trnRequestType: string;
    }
};

export interface TemplateSummary{
    trnType : string;
    templateCount: number;
}

export interface upsertTemplateData {
    templateId: any;
    templateName: string;
    trnType: string;
    isFavorite: string;
    trnData:  any /*{
        trnRequestType: string;
        PMTCUSTID: string;
        CUSTCIF: string;
        CUSTACC: string;
        AMOUNT: number;
        BENEFACC: string;
        PMTDET: string;
        COMMAMOUNT: number;
        BENEFACCTYPE: string;
        BENEFNAME: string;
        note:  string;
    }*/
}

export interface deleteTemplateData{
    templates : {
        templateId : number
    }[]
}

export interface updateTemplateSeqData{
    templateId : number;
    favoriteSeq : number;
}

export const getTemplates = async (): Promise<Templates> => {
    const { data } = await http.get<Templates>(`transaction/template-get-params`);
    return data;
};

export const getTemplatesByParams = async (trnType : string='', isFavorite: string=''): Promise<Templates> => {
    let makeParam='';

    if (trnType!==''){
        makeParam +=`?trnType=${trnType}`;
    }

    if (isFavorite!==''){
        makeParam+=(makeParam!=='') ? '&' : '?';

        makeParam +=`isFavorite=${isFavorite}`;
    }

    const { data } = await http.get<Templates>(`transaction/template-get${makeParam}`);
    return data;
};

export const getTemplateSummary = async (): Promise<TemplateSummary> => {
    const { data } = await http.get<TemplateSummary>(`transaction/template-get-summary`);
    return data;
};

export const upsertTemplate = async (postData : upsertTemplateData): Promise<upsertTemplateData> => {
    const { data } = await http.post<upsertTemplateData>(`transaction/template-upsert`, postData);
    return data;
};

export const changeTemplateSeq = async (postData : updateTemplateSeqData): Promise<upsertTemplateData> => {
    const { data } = await http.post<upsertTemplateData>(`transaction/template-changeseq`, postData);
    return data;
};

export const deleteTemplate = async (postData : deleteTemplateData): Promise<deleteTemplateData> => {
    const { data } = await http.post<deleteTemplateData>(`transaction/template-delete`, postData);
    return data;
};
